/**
 * Helper (pure) ของปุ่มดาวน์โหลดในหน้า Direct Script — "Download All Audio" / "Download All Video"
 * บน toolbar ของ grid view และปุ่มเดิม (ไฟล์ final ไฟล์เดียว) ในมุมมอง Final Output
 *
 * ปุ่มบน toolbar เป็นการโหลดแบบ bulk "รายฉาก" ไม่ใช่ไฟล์รวมทั้งตอน: เสียงมาจาก `audio_url` และวิดีโอมาจาก
 * `segment_video_url` ของ `/output.items[]` (คือ segment ที่เรนเดอร์เสร็จแล้ว มีเสียง/overlay ครบ ไม่ใช่คลิป AI ดิบ)
 * แล้วรวมเป็น zip ไฟล์เดียวเรียงตามลำดับฉากบนจอ ตั้งชื่อ entry ด้วย "เลขฉากบนจอ" (`sceneNo` นับรวมฉากที่ปิดด้วย
 * เพื่อให้ `scene_03.mp4` ตรงกับป้าย "Scene 3" ที่ผู้ใช้เห็น) ส่วนฉากที่ปิดอยู่ไม่ถูกใส่ลง zip
 *
 * ทำไมจับคู่ฉากกับ output ด้วย id ตรง ๆ 1:1 ตามลำดับบน UI: จบ run แล้วหลังบ้านส่งรายการฉาก "หลังแตกฉากแล้ว"
 * (แม่ `3` + ลูก `3_2_<ts>`, `3_3_<ts>`) กลับมาทั้งใน `values.items` และ `final_script.items`
 * (graph.py: `"final_script": {**state["final_script"], "items": items}`) และการ์ดสร้าง `scriptWithImage`
 * จาก `final_script.items` ⇒ ฉากลูกเป็นฉากระดับบนสุดบน UI อยู่แล้ว มี `active` ของตัวเอง จึงไม่ต้องขยายจาก id
 * ของแม่ (ถ้าไปขยายซ้ำอีกจะได้ไฟล์ของฉากลูกซ้ำสองรอบ) และ output ที่ไม่มีฉากคู่บน UI (ฉากที่ถูกลบไปแล้ว)
 * ต้องไม่ถูกดึงมาปนใน zip
 *
 * zip สะท้อน "การจัดเรียงบนหน้าจอ ณ ตอนนี้" ไม่ใช่ลำดับใน mp4 ที่เรนเดอร์ไว้ก่อนหน้า: ตอน concat หลังบ้านเรียง
 * ฉากที่ seq เท่ากันด้วย "เลขท้าย id" (graph.py `id_num`) ⇒ ฉากที่สร้างจากปุ่ม New Scene (id = `Date.now()`
 * 13 หลัก) เมื่อถูกแตก ฉากลูกจะลงท้ายด้วย timestamp หน่วยวินาที (10 หลัก) ซึ่งน้อยกว่า id ของแม่ ⇒ ใน mp4
 * ลูกถูกเรนเดอร์ก่อนแม่ ขณะที่ UI/zip ยังเป็นแม่ก่อนลูก นี่คือ quirk ของหลังบ้าน อย่าดัดลำดับ zip ให้ตามมัน
 *
 * ทำไมทุกการตัดสินใจอิง "URL ของไฟล์" ไม่ใช่ flag ของ run:
 * - run ที่ติ๊ก Generate Audio Only เขียน `final_podcast.mp3` แล้วส่งกลับมาใน field เดียวกับวิดีโอ
 *   (`final_video_url`) ⇒ ชนิดไฟล์ final รู้ได้จากนามสกุลเท่านั้น (ของเดิม hardcode `.mp4` ตอนตั้งชื่อ)
 * - `finalVideoUrl` ของการ์ดต่อท้าย `?v=<mediaVersion>` กัน cache ⇒ ต้องตัด query/hash ก่อนอ่านนามสกุล
 * - `outputData` / `graphState` ไม่เคยถูกเคลียร์ตอนสลับ run (พฤติกรรมเดิม) ⇒ URL ที่ค้างจาก run ก่อน
 *   ต้องถือว่า "ยังไม่มีไฟล์" ตรวจโดยดูว่า path อยู่ใต้ `/static/{thread}/` ของ run ปัจจุบันจริงไหม
 *
 * ทำไมต้องดึงไฟล์ด้วย `fetch` เอง: การรวม zip ต้องอ่านเนื้อไฟล์เข้ามาก่อนอยู่แล้ว และทางเลือก "ปล่อยหลายไฟล์"
 * ด้วย `<a download>` ใช้กับ URL ข้าม origin ไม่ได้ (เบราว์เซอร์ไม่ยอมตั้งชื่อไฟล์/ไม่บังคับดาวน์โหลด กลายเป็น
 * เปิดแท็บแทน) ⇒ ไม่ว่าจะเลือกทางไหน origin ของหน้าเว็บก็ต้องอยู่ใน allowlist CORS ของ MeGen API
 * ข้อความ error ของ `fetch_failed` จึงบอกทั้ง host ของ API และ origin ปัจจุบัน เพราะ `fetch` reject เป็น
 * `TypeError` เหมือนกันหมดทั้งตอนเน็ตหลุดและตอนโดน CORS บล็อก แยกจากตัว error ไม่ได้
 *
 * ไฟล์นี้ไม่แตะ DOM/network เลย (ส่วนนั้นอยู่ใน `browserZipDownload.ts`) เพื่อให้เทสต์แบบ node ได้
 */
import { DirectScriptOutputItem, ScriptWithImageItem } from "../types/MeGenTypes";

/** ชนิดงานดาวน์โหลด — ใช้เป็นทั้ง key ของงานที่กำลังทำและตัวเลือกข้อความ error
 *  "final" = ปุ่มเดิมในมุมมอง Final Output (ไฟล์ทั้งตอนไฟล์เดียว) · "audio-zip"/"video-zip" = ปุ่ม bulk บน toolbar
 *  · "script" = ไฟล์ .txt ของข้อความที่อ่านออกเสียง บน toolbar เหมือนกัน (ไม่ได้โหลดไฟล์สื่อ แต่ใช้ runner/สถานะปุ่มชุดเดียวกัน) */
export type EpisodeMediaKind = "final" | "audio-zip" | "video-zip" | "script";

/** ชนิดของ "ไฟล์ final" ที่มีอยู่ — แยกจาก `EpisodeMediaKind` เพราะเป็นคนละแกน (ชนิดไฟล์ ไม่ใช่ชนิดปุ่ม) */
export type FinalMediaKind = "audio" | "video";

/** สาเหตุที่ดาวน์โหลดไม่สำเร็จ — แยกเป็น code เพราะข้อความไทยต้องประกอบที่ชั้น UI ไม่ใช่ชั้น fetch/zip */
export type EpisodeDownloadErrorCode =
  | "aborted"
  | "fetch_failed"
  | "http_error"
  | "zip_failed"
  | "empty_file"
  | "no_sources";

/** error ของงานดาวน์โหลด — `message` ใช้เก็บรายละเอียดดิบ (เช่น HTTP status) ไม่ใช่ข้อความที่โชว์ผู้ใช้ */
export class EpisodeDownloadError extends Error {
  code: EpisodeDownloadErrorCode;

  constructor(code: EpisodeDownloadErrorCode, message?: string) {
    super(message ?? code);
    this.name = "EpisodeDownloadError";
    this.code = code;
    // build ที่ compile class ลง ES5 ทำให้ prototype ของ subclass ของ Error หลุด ⇒ instanceof พัง ต้องตั้งคืนเอง
    Object.setPrototypeOf(this, EpisodeDownloadError.prototype);
  }
}

/** ยกเลิกเอง (สลับ run / unmount) ไม่ใช่ความผิดพลาด ⇒ ห้ามเด้ง snack
 *  รูปที่เจอได้: DOMException/Error ชื่อ "AbortError" จาก fetch หรือ error ของเราเองที่ code = "aborted" */
export const isAbortError = (err: unknown): boolean => {
  if (err instanceof EpisodeDownloadError) return err.code === "aborted";
  return typeof err === "object" && err !== null && (err as { name?: unknown }).name === "AbortError";
};

/** เอาเฉพาะส่วน path — `#…` และ `?…` (cache buster `?v=<mediaVersion>`) ต้องไม่ปนเข้าไปในนามสกุล/ชื่อไฟล์ */
const pathPartOf = (url: string): string => url.split("#")[0].split("?")[0];

/** ชื่อไฟล์ท้าย path (ไม่รวม query/hash) */
const basenameOf = (url: string): string => {
  const segments = pathPartOf(url).split("/");
  return segments[segments.length - 1];
};

/** นามสกุลตัวเล็กของไฟล์ใน URL — "" เมื่อไม่มีนามสกุล (เช่น URL ว่างหรือ path ที่ไม่ใช่ไฟล์) */
export const mediaExtFromUrl = (url: string | null | undefined): string => {
  if (!url) return "";
  const file = basenameOf(url);
  const dot = file.lastIndexOf(".");
  return dot < 0 ? "" : file.slice(dot + 1).toLowerCase();
};

/** นามสกุลที่ถือว่าเป็น "ไฟล์เสียง" — หลังบ้านเขียน mp3 อย่างเดียว ที่เหลือเผื่อไฟล์ที่ผู้ใช้อัปโหลดเอง */
export const AUDIO_MEDIA_EXTS: ReadonlySet<string> = new Set(["mp3", "wav", "m4a", "aac", "ogg", "opus"]);

/** ไฟล์ final เป็นเสียงหรือวิดีโอ — `null` = ยังไม่มีไฟล์ final (ยังไม่ได้กด Generate Video) */
export const finalMediaKindFromUrl = (url?: string | null): FinalMediaKind | null => {
  const ext = mediaExtFromUrl(url);
  if (!ext) return null;
  return AUDIO_MEDIA_EXTS.has(ext) ? "audio" : "video";
};

/** ชื่อไฟล์ที่หลังบ้านเขียนจริง: final = `final_podcast.*` · review 480p = `final_podcast_review_480p.*` */
const FINAL_RENDER_FILE_RE = /^final_podcast(_review_480p)?\.[a-z0-9]+$/i;

/** ไฟล์ที่ได้มาเป็นงาน review (480p) ไหม — เชื่อชื่อไฟล์ก่อนเสมอ เพราะ `render_mode` ของ state
 *  อาจเป็นของรอบที่กำลังจะเรนเดอร์ ไม่ใช่ของไฟล์ที่มีอยู่จริง; ใช้ `renderMode` ต่อเมื่อชื่อไฟล์ไม่บอกอะไร */
export const isReviewRender = (url?: string | null, renderMode?: string | null): boolean => {
  const match = url ? FINAL_RENDER_FILE_RE.exec(basenameOf(url)) : null;
  if (match) return Boolean(match[1]);
  return renderMode === "review";
};

/** ชื่อไฟล์ segment ของฉาก: `segment_{id}_review.mp4` (งาน review) · `segment_{id}_final.mp4` (งาน final) */
const REVIEW_SEGMENT_FILE_RE = /^segment_.+_review\.[a-z0-9]+$/i;

/** ไฟล์ segment ที่มีอยู่มาจากงาน review ไหม — zip ตั้งชื่อตามไฟล์ที่ได้จริง ไม่ใช่ `render_mode` ของ state
 *  (state อาจเป็นของรอบที่กำลังจะเรนเดอร์ ⇒ zip ของ review อาจถูกตั้งชื่อทับ zip ของ final) */
export const isReviewSegmentUrl = (url?: string | null): boolean =>
  url ? REVIEW_SEGMENT_FILE_RE.test(basenameOf(url)) : false;

/** ตัดอักขระที่ตั้งชื่อไฟล์ไม่ได้ทิ้ง (คงตัวอักษรไทยไว้) — regex เดิมจาก `handleDownloadFinalVideo` */
export const sanitizeDownloadName = (name?: string | null, fallback = "final-output"): string => {
  const safe = (name || "").replace(/[^a-zA-Z0-9_\-\u0E00-\u0E7F ]/g, "_").trim();
  return safe || fallback;
};

/** ชื่อไฟล์ที่เซฟ — ต่อ `_review` เฉพาะไฟล์ที่มาจากงาน review เพื่อไม่ให้ทับไฟล์ final ของ run เดียวกัน
 *  `suffix` (เช่น `_audio` / `_video` ของ zip รายฉาก) มาก่อน `_review` เพื่อให้ไฟล์ของ run เดียวกันเรียงชิดกันเวลาจัดเรียงชื่อ */
export const downloadFilename = (p: {
  runName?: string | null;
  ext: string;
  review: boolean;
  suffix?: string;
}): string =>
  `${sanitizeDownloadName(p.runName)}${p.suffix ?? ""}${p.review ? "_review" : ""}.${p.ext}`;

/** ชื่อ entry ในไฟล์ zip — เติม 0 ให้ทุกชื่อยาวเท่ากัน (อย่างน้อย 2 หลัก) เพราะโปรแกรมแตกไฟล์/ตัวจัดการไฟล์
 *  เรียงตามชื่อแบบ string ⇒ `scene_2` จะไปอยู่หลัง `scene_10` ถ้าไม่เติม; ตอนที่มี 100 ฉากขึ้นไปใช้ 3 หลัก */
export const sceneZipEntryName = (sceneNo: number, sceneCount: number, ext: string): string =>
  `scene_${String(sceneNo).padStart(Math.max(2, String(sceneCount).length), "0")}.${ext}`;

/** URL ของ asset ทุกตัวเป็น `/static/{thread}/…` ⇒ ใช้ยืนยันว่าไฟล์เป็นของ run ที่เปิดอยู่จริง
 *  (กัน `outputData` ที่ค้างจาก run ก่อนหน้าตอนสลับ thread ซึ่งของเดิมไม่เคยเคลียร์) */
export const urlBelongsToThread = (
  url: string | null | undefined,
  threadId: string | null | undefined,
): boolean => {
  if (!url || !threadId) return false;
  return pathPartOf(url).includes(`/static/${threadId}/`);
};

/** field ของ `/output.items[]` ที่ปุ่ม bulk แต่ละปุ่มดึงไฟล์มาใส่ zip */
export type SceneAssetField = "audio_url" | "segment_video_url";

/** ไฟล์ของฉากหนึ่งฉากที่จะถูกใส่ลง zip — `sceneNo` = เลขฉากบนจอ (ใช้ตั้งชื่อ entry), `id` ไว้ debug/ทดสอบลำดับ */
export type EpisodeSceneSource = { id: string; url: string; sceneNo: number };

/** ผลการรวบรวมไฟล์รายฉาก — `missing` คือ id ของฉากที่ active แต่ยังไม่มีไฟล์ใช้ได้, `total` = จำนวนฉากที่ active */
export type EpisodeSceneSources = { sources: EpisodeSceneSource[]; missing: string[]; total: number };

/**
 * รายการไฟล์รายฉากของทั้งตอน (เสียงหรือวิดีโอตาม `field`) เรียงตามลำดับฉากบน UI แบบตัวต่อตัว
 *
 * `sceneNo` นับจากตำแหน่งในรายการเต็ม (index + 1) คือ **รวมฉากที่ปิดด้วย** เพื่อให้ตรงกับป้าย "Scene N"
 * บนจอ ส่วนฉากที่ปิดเองไม่ถูกใส่ลง zip และไม่ถูกนับใน `total`
 * ใช้ `active` ของฉากบน UI เท่านั้น: `/output` คืน `active: item.get("active", False)` ซึ่ง default เป็น
 * false ⇒ เชื่อไม่ได้ · ฉากที่เปิดแต่ยังไม่มีไฟล์ที่ใช้ได้เข้า `missing` แต่ยังนับใน `total`
 * (ปุ่มจะได้บอกได้ว่าครบกี่ฉากจากทั้งหมด)
 */
export const episodeSceneSources = (
  sceneItems: ReadonlyArray<Pick<ScriptWithImageItem, "id" | "active">>,
  outputItems: ReadonlyArray<Pick<DirectScriptOutputItem, "id" | "audio_url" | "segment_video_url">>,
  threadId: string | null | undefined,
  toUrl: (path: string) => string,
  field: SceneAssetField,
): EpisodeSceneSources => {
  const sources: EpisodeSceneSource[] = [];
  const missing: string[] = [];
  let total = 0;

  // ไฟล์ของฉากใช้ได้ก็ต่อเมื่อมี path ใน field นั้น และไฟล์อยู่ใต้ thread ที่เปิดอยู่จริง
  const usableUrl = (
    item: Pick<DirectScriptOutputItem, "id" | "audio_url" | "segment_video_url">,
  ): string | null => {
    const path = item[field];
    if (!path) return null;
    const url = toUrl(path);
    return urlBelongsToThread(url, threadId) ? url : null;
  };

  sceneItems.forEach((scene, index) => {
    if (scene.active === false) return;
    total += 1;

    const item = outputItems.find((output) => output.id === scene.id);
    const url = item ? usableUrl(item) : null;
    if (!url) {
      missing.push(scene.id);
      return;
    }
    sources.push({ id: scene.id, url, sceneNo: index + 1 });
  });

  return { sources, missing, total };
};

/** ไฟล์หนึ่งไฟล์ใน zip: URL ที่ต้องโหลด + ชื่อ entry ที่จะเห็นตอนแตกไฟล์ */
export type ZipEntry = { url: string; name: string };

/**
 * แปลงไฟล์รายฉากเป็นรายการ entry ของ zip
 *
 * นามสกุลมาจาก URL จริงของแต่ละฉาก ไม่ใช่ค่าตายตัว เพราะเสียงรายฉากเป็น wav หรือ mp3 ก็ได้ (แล้วแต่รอบที่เขียน)
 * ปนกันในตอนเดียวกันได้ด้วย · `fallbackExt` ใช้เมื่อ URL ไม่มีนามสกุลเลย จะได้ไม่เกิด entry ชื่อ `scene_01.`
 * `sceneCount` คือจำนวนฉากทั้งหมดบนจอ (ไม่ใช่จำนวนไฟล์) เพราะเลขที่เติม 0 ต้องกว้างพอสำหรับเลขฉากที่มากที่สุด
 */
export const zipEntriesFor = (
  sources: EpisodeSceneSource[],
  sceneCount: number,
  fallbackExt: string,
): ZipEntry[] =>
  sources.map((source) => ({
    url: source.url,
    name: sceneZipEntryName(source.sceneNo, sceneCount, mediaExtFromUrl(source.url) || fallbackExt),
  }));

/** เหตุผลที่ปุ่มถูกปิด — โชว์เป็น tooltip ให้ผู้ใช้รู้ว่าต้องทำอะไรก่อน */
export const REASON_BUSY = "รอให้การสร้างวิดีโอเสร็จก่อน";
export const REASON_DOWNLOADING = "กำลังดาวน์โหลด...";
export const REASON_NO_FINAL = "ยังไม่มีไฟล์ final — กด Generate Video ก่อน";
export const REASON_NO_SPOKEN_SCRIPT =
  "ยังไม่มีข้อความให้ดาวน์โหลด — ต้องมี scene ที่เปิดใช้อย่างน้อย 1 ฉาก";

/** บอกจำนวนฉากที่มีเสียงแล้ว (k/N) เพื่อให้ผู้ใช้รู้ว่าเหลืออีกกี่ฉากถึงจะโหลดเสียงทุกฉากได้ */
export const reasonMissingAudio = (missing: number, total: number): string =>
  total > 0 ? `ยังมีไฟล์เสียงไม่ครบทุกฉาก (${total - missing}/${total})` : "ยังไม่มีฉากที่เปิดใช้งาน";

/** วิดีโอรายฉากมีเฉพาะฉากที่ถูกเรนเดอร์ใน render_mode ปัจจุบัน ⇒ บอกทางแก้ (กด Generate) ไปด้วยเลย */
export const reasonMissingVideo = (missing: number, total: number): string =>
  total > 0
    ? `ยังมีวิดีโอไม่ครบทุกฉาก (${total - missing}/${total}) — กด Generate Video/Scene ก่อน`
    : "ยังไม่มีฉากที่เปิดใช้งาน";

/** สถานะของปุ่มหนึ่งปุ่ม — `reason` เป็น null เมื่อกดได้ (ปุ่มแสดงตลอดใน grid view แม้กดไม่ได้ layout จะได้นิ่ง) */
export type DownloadAction = { enabled: boolean; reason: string | null };

export type DownloadActions = {
  finalKind: FinalMediaKind | null;
  review: boolean;
  final: DownloadAction;
  audioZip: DownloadAction;
  videoZip: DownloadAction;
  script: DownloadAction;
};

const enabledAction = (): DownloadAction => ({ enabled: true, reason: null });
const disabledAction = (reason: string): DownloadAction => ({ enabled: false, reason });

/**
 * สถานะปุ่มดาวน์โหลดทั้งสี่ปุ่ม ลำดับความสำคัญ: กำลัง generate > มีงานดาวน์โหลดค้าง > กฎของแต่ละปุ่ม
 *
 * ปุ่ม zip ไม่พึ่งไฟล์ final เลย (โหลดได้ตั้งแต่ยังไม่ merge) แต่ต้องมีไฟล์ครบ **ทุกฉากที่เปิดอยู่**
 * เพราะ zip ที่ขาดบางฉากไปเงียบ ๆ ผู้ใช้จะจับไม่ได้จนกว่าจะแตกไฟล์ดู
 *
 * ปุ่ม script เป็นข้อยกเว้นของกฎ "กำลัง generate": ประกอบไฟล์จากสคริปต์ที่อยู่ในหน้าจอแล้ว
 * ไม่แตะไฟล์ที่กำลังถูกเขียนและไม่ยิง request ⇒ โหลดได้ระหว่างสร้างวิดีโอ แต่ยังทำ "ทีละงาน"
 * ร่วมกับปุ่มอื่นเพราะใช้ runner ตัวเดียวกัน · เงื่อนไขเดียวของมันคือต้องมีข้อความให้โหลดจริง
 */
export const downloadActions = (p: {
  finalUrl?: string | null;
  threadId?: string | null;
  renderMode?: string | null;
  isBusy: boolean;
  activeJob: EpisodeMediaKind | null;
  audio: { missing: number; total: number };
  video: { missing: number; total: number };
  script: { count: number };
}): DownloadActions => {
  // ไฟล์ final ที่ไม่ได้อยู่ใต้ thread ปัจจุบัน = ของ run ก่อนที่ยังค้างอยู่ ⇒ ถือว่ายังไม่มีไฟล์
  const finalKind = urlBelongsToThread(p.finalUrl, p.threadId)
    ? finalMediaKindFromUrl(p.finalUrl)
    : null;
  // review ผูกกับ finalKind: ไฟล์ที่ไม่ใช่ของ thread นี้ต้องไม่ทำให้ชื่อไฟล์ติด _review ของ run อื่น
  const review = finalKind !== null && isReviewRender(p.finalUrl, p.renderMode);

  // ไม่ผ่าน isBusy ⇒ ต้องคำนวณก่อน allDisabled แล้วส่งค่าเดียวกันนี้เข้าไปทุกทาง
  const script = p.activeJob
    ? disabledAction(REASON_DOWNLOADING)
    : p.script.count === 0
    ? disabledAction(REASON_NO_SPOKEN_SCRIPT)
    : enabledAction();

  const allDisabled = (reason: string): DownloadActions => ({
    finalKind,
    review,
    final: disabledAction(reason),
    audioZip: disabledAction(reason),
    videoZip: disabledAction(reason),
    script,
  });

  if (p.isBusy) return allDisabled(REASON_BUSY);
  if (p.activeJob) return allDisabled(REASON_DOWNLOADING);

  const final = finalKind !== null ? enabledAction() : disabledAction(REASON_NO_FINAL);

  const audioZip =
    p.audio.total > 0 && p.audio.missing === 0
      ? enabledAction()
      : disabledAction(reasonMissingAudio(p.audio.missing, p.audio.total));

  const videoZip =
    p.video.total > 0 && p.video.missing === 0
      ? enabledAction()
      : disabledAction(reasonMissingVideo(p.video.missing, p.video.total));

  return { finalKind, review, final, audioZip, videoZip, script };
};

/** ข้อความกลาง ๆ ของ error ที่ไม่รู้จัก — แยกตามปุ่มที่กด เพราะผู้ใช้ต้องรู้ว่าปุ่มไหนพัง (บนจอมีสี่ปุ่ม) */
const FALLBACK_MESSAGE_BY_KIND: Record<EpisodeMediaKind, string> = {
  final: "ดาวน์โหลดไฟล์ final ไม่สำเร็จ",
  "audio-zip": "ดาวน์โหลดไฟล์เสียงทุกฉากไม่สำเร็จ",
  "video-zip": "ดาวน์โหลดวิดีโอทุกฉากไม่สำเร็จ",
  script: "ดาวน์โหลดสคริปต์ไม่สำเร็จ",
};

/** ข้อความไทยที่เด้งผ่าน SnackMessage ของ parent — บอกสาเหตุพอให้ผู้ใช้ตัดสินใจได้ว่าลองใหม่ รอ หรือไปแก้ที่ระบบ
 *  `ctx` ต้องส่ง host ของ API กับ origin ของหน้าเข้ามา เพราะ CORS ที่ไม่ผ่านแยกจากเน็ตหลุดด้วย error ไม่ได้
 *  ผู้ใช้/คนดูแลระบบต้องเห็นคู่นี้ถึงจะรู้ว่าต้องเพิ่ม origin ไหนเข้า allowlist ของ MeGen API */
export const downloadErrorMessage = (
  err: unknown,
  kind: EpisodeMediaKind,
  ctx: { origin: string; apiHost: string },
): string => {
  const fallback = FALLBACK_MESSAGE_BY_KIND[kind];
  if (!(err instanceof EpisodeDownloadError)) return fallback;

  switch (err.code) {
    case "http_error":
      return `เซิร์ฟเวอร์ตอบ ${err.message} — ไม่พบไฟล์หรือไฟล์ยังไม่พร้อม`;
    case "fetch_failed":
      return `โหลดไฟล์จาก ${ctx.apiHost} ไม่สำเร็จ — ตรวจสอบการเชื่อมต่อ หรือ origin ${ctx.origin} ยังไม่อยู่ใน allowlist (CORS) ของ MeGen API`;
    case "zip_failed":
      return "สร้างไฟล์ zip ไม่สำเร็จ";
    case "empty_file":
      // message = ชื่อ entry ที่ได้ไฟล์ 0 ไบต์ (S3 lazy-download ค้าง) — บอกฉากให้ผู้ใช้ไปเรนเดอร์ซ้ำถูกตัว
      return `ไฟล์ ${err.message} บนเซิร์ฟเวอร์ว่างเปล่า (0 ไบต์) — ไฟล์ยังไม่พร้อม ลองใหม่ภายหลังหรือ Generate ฉากนั้นใหม่`;
    case "no_sources":
      return "ยังไม่มีไฟล์ให้ดาวน์โหลด";
    default:
      return fallback;
  }
};
